import {apiClient, authHeaders} from "./apiClient";

import {
    Category,
    Collection,
    Order,
    Product,
    User,
    Review,
    HomeSlidingPhoto,
    Subscriber, Booking
} from "../interfaces/interfaces";

export const token = () => localStorage.getItem('admin_token');

export const getProducts = (): Promise<Product[]> => apiClient.get(
    '/products',
    authHeaders(token()))
    .then((r: any) => r.data as Product[]);

export const createProduct = (fd: FormData): Promise<Product> => apiClient.post(
    '/products',
    fd,
    {
        headers: {
            ...authHeaders(token()).headers,
            'Content-Type': undefined
        }
    }).then((r: any) => r.data as Product);


export const updateProduct = (id: number, fd: FormData): Promise<Product> => apiClient.put(
    `/products/${id}`,
    fd,
    {
        headers: {
            ...authHeaders(token()).headers,
            'Content-Type': undefined
        }
    }).then((r: any) => r.data as Product);

export const deleteProduct = (id: number) => apiClient.delete(
    `/products/${id}`,
    authHeaders(token())
);


export const getCollections = (): Promise<Collection[]> => apiClient.get(
    '/collections',
    authHeaders(token()))
    .then((r: any) => r.data as Collection[]);


export const getCategories = (): Promise<Category[]> => apiClient.get(
    '/categories',
    authHeaders(token()))
    .then((r: any) => r.data as Category[]);


export const getUsers = (): Promise<User[]> => apiClient.get('/users', authHeaders(token()))
    .then((r: any) => r.data as User[]);

export const updateUser = (id: number, role: string): Promise<User> => apiClient.put(`/users/${id}`, {role}, authHeaders(token()))
    .then((r: any) => r.data as User);

export const deleteUser = (id: number) => apiClient.delete(`/users/${id}`, authHeaders(token()));


export const getOrders = (): Promise<Order[]> => apiClient.get('/orders', authHeaders(token()))
    .then((r: any) => r.data as Order[]);

export const createOrder = (order: {
    customerName: string;
    customerPhone: string;
    total: number;
    items: { productId: number; qty: number; price: string; }[]
}): Promise<any> => apiClient.post(
    '/orders',
    order,
    authHeaders(token()))
    .then((r: any) => r.data as Order);

export const updateOrder = (id: number, status: string): Promise<Order> => apiClient.put(`/orders/${id}`, {status}, authHeaders(token()))
    .then((r: any) => r.data as Order);


export const getReviews = (): Promise<Review[]> => apiClient.get('/reviews', authHeaders(token()))
    .then((r: any) => r.data as Review[]);

export const createReview = (review: {
                                 customerName: string;
                                 title: string;
                                 content: string;
                                 rating: number;
                             }
): Promise<any> => apiClient.post(
    '/reviews',
    review,
    authHeaders(token()))
    .then((r: any) => r.data as Review);


export const deleteReview = (id: number) => apiClient.delete(`/reviews/${id}`, authHeaders(token()));

export const respondToReview = (id: number, response: string): Promise<Review> =>
    apiClient.put(`/reviews/${id}/response`, { response }, authHeaders(token())).then((r: any) => r.data as Review);

export const getHomeSlidingPhotos = (active?: boolean): Promise<HomeSlidingPhoto[]> => apiClient.get(
    '/home-sliding-photos',
    {
        ...authHeaders(token()),
        params: { active }
    })
    .then((r: any) => r.data as HomeSlidingPhoto[]);

export const getGalleryPhotos = (homeSlidingPhotoId: number) =>
    apiClient.get(`/gallery-photos/${homeSlidingPhotoId}`, authHeaders(token()))
        .then((r: any) => r.data);

export const addGalleryPhoto = (homeSlidingPhotoId: number, image: File) => {
    const fd = new FormData();
    fd.append('image', image);
    return apiClient.post(`/gallery-photos/${homeSlidingPhotoId}`, fd, authHeaders(token()));
};

export const deleteGalleryPhoto = (id: number) =>
    apiClient.delete(`/gallery-photos/${id}`, authHeaders(token()));

export const subscribeNewsletter = (fd: FormData): Promise<Subscriber> =>
    apiClient.post(
        '/newsletter/subscriptions/subscribe',
        fd,
        {
            headers: {
                ...authHeaders(token()).headers,
                'Content-Type': 'application/json'
            }
        }
    ).then((r: any) => r.data as Subscriber);

export const bookWorkshop = (fd: FormData): Promise<Booking> =>
    apiClient.post(
        '/workshop/bookings',
        fd,
        {
            headers: {
                ...authHeaders(token()).headers,
                'Content-Type': 'application/json'
            }
        }
    ).then((r: any) => r.data as Booking);
